import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {environment} from "../environments/environment";

import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MaterialModule} from './material.module';
import {NavUserComponent} from './utils/nav/nav-user/nav-user.component';
import {NavGuestComponent} from './utils/nav/nav-guest/nav-guest.component';
import {MapComponent} from './utils/map/map.component';
import {LanguagePickerComponent} from './utils/language-picker/language-picker.component';
import {LanguagePickerService} from './utils/language-picker/language-picker.service';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {NewOrderPickerComponent} from './utils/new-order-picker/new-order-picker.component';
import {NavLinkComponent} from './utils/nav-link/nav-link.component';
import {HomeHeaderComponent} from './home/home-header/home-header.component';
import {HomeOverviewComponent} from './home/home-orders/home-orders.component';
import {SearchButtonComponent} from './utils/search-button/search-button.component';
import {HomeOrdersService} from './home/home-orders/home-orders.service';
import {i18nService} from './service-utils/i18n.service';
import {YoutubeComponent} from './home/home-youtube/youtube.component';
import {YoutubeService} from './home/home-youtube/youtube.service';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {YoutubeVideoComponent} from './utils/youtube-video/youtube-video.component';
import {HomeContactComponent} from './home/home-contact/home-contact.component';
import {HomeOrdersDialogComponent} from './home/home-orders/home-orders-dialog/home-orders-dialog.component';
import {HomeCatalogueComponent} from './home/home-catalogue/home-catalogue.component';
import {CatalogueItemComponent} from './utils/catalogue-item/catalogue-item.component';
import {HomeAboutComponent} from './home/home-about/home-about.component';
import {HomeComponent} from './home/home/home.component';
import {AppRoutingModule} from './app-routing.module';
import {AdminPanelComponent} from './admin/admin-panel/admin-panel.component';
import {NavAdminComponent} from './utils/nav/nav-admin/nav-admin.component';
import {AdminComponent} from './admin/admin/admin.component';
import {AdminSettingsComponent} from './admin/admin-settings/admin-settings.component';
import {UserAdminComponent} from './admin/user-admin/user-admin.component';
import {UserAdminService} from './admin/user-admin/user-admin.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {UserAdminDialogComponent} from './admin/user-admin/user-admin-dialog/user-admin-dialog.component';
import {AdminSettingsService} from './admin/admin-settings/admin-settings.service';
import {SuperAdminComponent} from './super-admin/super-admin/super-admin.component';
import {SuperAdminPanelComponent} from './super-admin/super-admin-panel/super-admin-panel.component';
import {UserSuperAdminComponent} from './super-admin/user-super-admin/user-super-admin.component';
import {UserSuperAdminDialogComponent} from './super-admin/user-super-admin/user-super-admin-dialog/user-super-admin-dialog.component';
import {UserSuperAdminService} from './super-admin/user-super-admin/user-super-admin.service';
import {AccountSuperAdminComponent} from './super-admin/account-super-admin/account-super-admin.component';
import {AccountSuperAdminService} from './super-admin/account-super-admin/account-super-admin.service';
import {SuperAdminChannelComponent} from './super-admin/super-admin-channel/super-admin-channel.component';
import {AccountSuperAdminDialogComponent} from './super-admin/account-super-admin/account-super-admin-dialog/account-super-admin-dialog.component';
import {YoutubeVideoDialogComponent} from './utils/youtube-video/youtube-video-dialog/youtube-video-dialog.component';
import {RegisterDialogComponent} from './utils/nav-link/register-dialog/register-dialog.component';
import {PasswordRecoveryDialogComponent} from './utils/nav-link/password-recovery-dialog/password-recovery-dialog.component';
import {NewOrderSelectDialogComponent} from './new-order/new-order-select-dialog/new-order-select-dialog.component';
import {NewOrderStoreService} from './new-order/new-order-store-service.service';
import {NewOrderComponent} from './new-order/new-order/new-order.component';
import {NavNewOrderComponent} from './utils/nav/nav-new-order/nav-new-order.component';
import {NewOrderProposalComponent} from './new-order/new-order-proposal/new-order-proposal.component';
import {SpectacularRefractionComponent} from './new-order/new-order-proposal/spectacular-refraction/spectacular-refraction.component';
import {CentralRadiusComponent} from './new-order/new-order-proposal/central-radius/central-radius.component';
import {LensSideCircleComponent} from './utils/lens-side-circle/lens-side-circle.component';
import {CopySwitchButtonComponent} from './utils/copy-switch-button/copy-switch-button.component';
import {EccentricityDialogComponent} from './new-order/new-order-proposal/eccentricity-dialog/eccentricity-dialog.component';
import {TrialLensComponent} from './new-order/new-order-trial-lens-with-overrefarction/trial-lens/trial-lens.component';
import {NewOrderTrialLensWithOverrefractionComponent} from './new-order/new-order-trial-lens-with-overrefarction/new-order-trial-lens-with-overrefraction.component';
import {OverRefractionComponent} from './new-order/new-order-trial-lens-with-overrefarction/over-refraction/over-refraction.component';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {NewParameterComponent} from './new-order/new-order-trial-lens-with-overrefarction/new-parameter/new-parameter.component';
import {CalculationComponent} from './new-order/new-order-trial-lens-with-overrefarction/calculation/calculation.component';
import {NewOrderFinalLensComponent} from './new-order/new-order-final-lens/new-order-final-lens.component';
import {FinalLensComponent} from './new-order/new-order-final-lens/final-lens/final-lens.component';
import {CareAndAccessoriesService} from './new-order/care-and-accessories.service';
import {CartComponent} from './utils/cart/cart.component';
import {CartService} from './utils/cart/cart.service';
import {NewOrderConfirmComponent} from './new-order/new-order-confirm/new-order-confirm.component';
import {SuperAdminLoginComponent} from './super-admin/super-admin-login/super-admin-login.component';
import {PasswordResetComponent} from './auth/password-reset/password-reset.component';
import {ReturnComponent} from './return/return/return.component';
import {ReturnSideComponent} from './return/return-side/return-side.component';
import {ReturnStoreService} from './return/return-store.service';
import {ReturnCorrectionDialogComponent} from './return/return-correction-dialog/return-correction-dialog.component';
import {NavReturnComponent} from './utils/nav/nav-return/nav-return.component';
import {ValidatorService} from './service-utils/validator-service';
import {ValidationErrorComponent} from './utils/validation-error/validation-error.component';
import {ResponseViewComponent} from './new-order/new-order-proposal/response-view/response-view.component';
import {NewOrderProposalService} from './new-order/new-order-proposal/new-order-proposal.service';
import {NewOrderTrialLensWithOverRefractionService} from './new-order/new-order-trial-lens-with-overrefarction/new-order-trial-lens-with-overrefraction.service';
import {SaveDiscardOrderDialogComponent} from './utils/save-discard-order-dialog/save-discard-order-dialog.component';
import {OrdersApiService} from './api/orders-api.service';
import {CareComponent} from './new-order/new-order-care/care.component';
import {AccessoriesComponent} from './new-order/new-order-accessories/accessories.component';
import {GlobalStorageService} from './service-utils/global-storage.service';
import {HomeOrdersCopyDialogComponent} from './home/home-orders/home-orders-copy-dialog/home-orders-copy-dialog.component';
import {MatPaginationIntlService} from "./home/home-orders/home-orders-paginator.service";
import {MatPaginatorIntl} from "@angular/material/paginator";
import {HomeFirefoxDialogComponent} from './home/home-firefox-dialog/home-firefox-dialog.component';
import {HomeScreenComponent} from './home/home-screen/home-screen.component';
import {ValidationWarningComponent} from './utils/validation-warning/validation-warning.component';
import {SuperAdminCatalogsComponent} from './super-admin/super-admin-catalogs/super-admin-catalogs.component';
import {SuperAdminOrderingComponent} from "./super-admin/super-admin-ordering/super-admin-ordering.component";
import {SuperAdminBannerComponent} from "./super-admin/super-admin-banner/super-admin-banner.component";
import {ManufacturingPageComponent} from "./super-admin/manufacturing-page/manufacturing-page.component";
import {DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {CustomDateAdapter} from "./utils/custom-date-adapter";
import {
  ApexAccountSuperAdminComponent
} from "./super-admin/apex-account-super-admin/apex-account-super-admin.component";

@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    NavUserComponent,
    NavGuestComponent,
    LanguagePickerComponent,
    NewOrderPickerComponent,
    NavLinkComponent,
    HomeHeaderComponent,
    HomeOverviewComponent,
    SearchButtonComponent,
    YoutubeComponent,
    YoutubeVideoComponent,
    HomeContactComponent,
    HomeOrdersDialogComponent,
    HomeOrdersCopyDialogComponent,
    HomeCatalogueComponent,
    CatalogueItemComponent,
    HomeAboutComponent,
    HomeComponent,
    AdminPanelComponent,
    NavAdminComponent,
    AdminComponent,
    AdminSettingsComponent,
    UserAdminComponent,
    UserAdminDialogComponent,
    SuperAdminComponent,
    SuperAdminPanelComponent,
    UserSuperAdminComponent,
    UserSuperAdminDialogComponent,
    AccountSuperAdminComponent,
    SuperAdminChannelComponent,
    AccountSuperAdminDialogComponent,
    YoutubeVideoDialogComponent,
    RegisterDialogComponent,
    PasswordRecoveryDialogComponent,
    NewOrderSelectDialogComponent,
    NewOrderComponent,
    NavNewOrderComponent,
    NewOrderProposalComponent,
    SpectacularRefractionComponent,
    CentralRadiusComponent,
    LensSideCircleComponent,
    CopySwitchButtonComponent,
    EccentricityDialogComponent,
    TrialLensComponent,
    NewOrderTrialLensWithOverrefractionComponent,
    OverRefractionComponent,
    NewParameterComponent,
    CalculationComponent,
    NewOrderFinalLensComponent,
    FinalLensComponent,
    CartComponent,
    NewOrderConfirmComponent,
    SuperAdminLoginComponent,
    PasswordResetComponent,
    ReturnComponent,
    ReturnSideComponent,
    ReturnCorrectionDialogComponent,
    NavReturnComponent,
    ValidationErrorComponent,
    ResponseViewComponent,
    SaveDiscardOrderDialogComponent,
    CareComponent,
    AccessoriesComponent,
    HomeFirefoxDialogComponent,
    HomeScreenComponent,
    ValidationWarningComponent,
    SuperAdminCatalogsComponent,
    SuperAdminOrderingComponent,
    SuperAdminBannerComponent,
    ManufacturingPageComponent,
    ApexAccountSuperAdminComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FontAwesomeModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMatSelectSearchModule,
  ],
  providers: [
    LanguagePickerService,
    HomeOrdersService,
    i18nService,
    YoutubeService,
    UserAdminService,
    UserSuperAdminService,
    AdminSettingsService,
    AccountSuperAdminService,
    NewOrderStoreService,
    CareAndAccessoriesService,
    CartService,
    ReturnStoreService,
    ValidatorService,
    NewOrderProposalService,
    NewOrderTrialLensWithOverRefractionService,
    OrdersApiService,
    GlobalStorageService,
    {provide: MatPaginatorIntl, useClass: MatPaginationIntlService,},
    {provide: DateAdapter, useClass: CustomDateAdapter},
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private dateAdapter: DateAdapter<Date>) {
    this.dateAdapter.setLocale('en-GB');
    //this.dateAdapter.setLocale('en-en');
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.apiUrl + '/i18n/', '.json');
}
